import React, { useEffect, useState } from 'react'
import { ShowAdminIssueDetailsWrapper } from './ShowAdminIssueDetails.style'
import QuestionDetails from 'components/comman/modalComponents/questionDetails/QuestionDetails'
import { getDate } from 'helper/utils'
import JsonFormatter from 'react-json-formatter';
import { saveAs } from 'file-saver';
import { IqLink } from 'helper/constants';
import SecuredServices from 'api/securedServices';
import { Button, Input, message,Select } from 'antd';
import GenricModal from 'components/comman/modalComponents/modal/modal';
import { useNavigate } from 'react-router-dom';
import Spinner from "assets/images/Spinner.gif";

export default function ShowAdminIssueDetails({data}) {

  const [concepts,setConcepts] = useState([]);
  const [selectedConcept,setSelectedConcept] = useState({concept_id:-1,concept_name:""});
  const [addNewConceptModal,setAddNewConceptModal] = useState(false);
  const [hardness,setHardness] = useState();
  const [testMcqModal,setTestMcqModal] = useState(false);
  const [mcqJson,setMcqJson]  = useState([]);
  const [comments,setComments] = useState([]);
  const [mcqTestData,setMcqTestData] = useState([]);
  const [images,setImages] = useState([]);
  const [showProgressBar,setShowProgressBar] = useState(false);

  const navigate = useNavigate();

  useEffect(()=>{
    if(data && data.description){
        let comm = JSON.parse(data.description);
        console.log(comm);
        let commfinal = comm.map((ele,index)=>{
            return {
                index:index+1,
                step_id:ele.step_id,
                issueAt: ele.step_no==-1?"Question":ele.step_no==0?"Final Answer":`Step No. ${ele.step_no}`,
                comment: ele.description,
            }   
        });
        setComments(commfinal);
        console.log(commfinal);

    }
    setImages(data.images?data.images:[]);


},[])




  const jsonStyle = {
    propertyStyle: { color: 'red' },
    stringStyle: { color: 'green' },
    numberStyle: { color: 'darkorange' }
  }


//   useEffect(()=>{

//     SecuredServices.getConcepts(data.topic_id).then((res)=>{
//         if(res.data.status==1){
//             setConcepts(res.data.data.data);
//             console.log(res.data.data.data);
//         }
//     })
//     setHardness(data.hardness);

// },[data.topic_id])

useEffect(()=>{
  console.log(data);
  if(data.type=="Mcq"){
  let mcqJs = [];
    data?.programDetails.forEach((program)=>{
      let d = {
        mcq_json: program.mcq_json,
      }
      mcqJs.push(d);
  })
  setMcqJson(mcqJs);
}
},[data])

useEffect(()=>{
  setSelectedConcept({concept_id:data.concept_id,concept_name:data.concept_name});
},[data.concept_id,data.concept_name])

  const handleDownLoadQATex = (attachments)=>{
    console.log(attachments);
    let link =attachments.find(att=>att.attachment_type=="Tex file")?.attachment_link;
    window.location.href=link;
  }

  const handleClickDownloadResources = (data,qName,type)=>{
    console.log(data,type);
    let text;
    if(type=="Mission"){
      text = {
        program:data.program,
        rubrics:JSON.parse(data.rubrics)
      }
    }
    else if(type=="Mcq"){
        console.log(type);
        text = {};
        data?.forEach((d,index)=>{
          text[`question ${index+1}`] = d?.mcq_json;
        })
        console.log(text);
    }
    else{
      text= {
        q_tex:data.q_tex,
        a_tex:data.a_tex,
        iq_annotation:data.iq_annotation
      };
    }
    

    saveAs(new Blob([JSON.stringify(text, null, 2)], { type: 'text/plain;charset=utf-8' }), `${qName}_resources.json`);

  }

  const handleClickPracticeLink = ()=>{
    if(data.type=="Mission"){
      window.open(data.programDetails.attachments[0].pdf_link,'_blank','noopener,noreferrer');
    }
    else if(data.type=="mcq"){
      
      let tempD = JSON.parse(data.mcq_json);
      tempD = tempD.map((item, index) => {
        return JSON.stringify(item);
      })
      console.log(tempD);
      let mcqtestd = tempD.map((item, index) => {
        return {index:index+1,mcq_json:item}
    })
      setMcqTestData(mcqtestd);
      setTestMcqModal(true);
    }
    else{
      let link = `${IqLink}ip-verify/${data.token}/-1/${data.instance_id}`;
      window.open(link,'_blank','noopener,noreferrer');
    }
   
  }

  const handleClickCommit = ()=>{
    setShowProgressBar(true);
      let data1 = {
        prod_id:data.prod_id,
        type:data.type,
        q_tex:data.q_tex,
        a_tex:data.a_tex,
        iq_annotation:data.iq_annotation,
        mcq_json:data.mcq_json,
        live_q_name:data.live_q_name,
        concept_id:data.concept_id,
        instance_id:data.instance_id,
      };
      SecuredServices.commitIssueReportedAfterFix(data1).then((res)=>{
        console.log(res.data);
        if(res.data.status==1){
          message.success(res.data.message);
          //reload the page
          window.location.reload();
        }
        else{
          message.error(res.data.message);
        }
      }).catch((err)=>{
        console.log(err);
      }).finally(()=>{
        setShowProgressBar(false);
      })
    }


    const handleClickRevert = ()=>{
    
   
     let qdata = {
      issue_id: data.id
     }
     
      
      SecuredServices.revertIssueBackToIssueFixer(qdata).then((res)=>{
        console.log(res.data);
        if(res.data.status==1){
          message.success(res.data.message);
          //reload the page
          window.location.reload();
        }
        else{
          message.error(res.data.message);
        }
      }).catch((err)=>{
        console.log(err);
      })
    }



  return (
    <ShowAdminIssueDetailsWrapper>
        <div className='questionDetails'>
            <div className='row'>
                <div className='col'><b>Q-Name :</b> Issue-{data?.id}</div>
                <div className='col'><b>Type :</b> {data?.type}</div>
            </div>
        </div>
       
        <div className='verifierSection'>
            <p className='verifiers'>Issue Details</p>
            <div>
                <div className="row">
                     <div className="col"><b>Issue Fixed By :</b> {data?.fullname}</div>
                     <div className="col"><b>Submit Date:</b> {getDate(data?.submittedAt)}</div>
                </div> 
            </div>

            {<><div className='imageP'><p>Issue Images :</p></div>
            <div className='imagesection'>
           { images.map((ele,index)=>{
                return(
                    <div key={index} className='images'>
                        <img className='image' src={ele.image_url} alt="" />
                    </div>
                )
            })
            }
                    
            </div>
            </>
            }


           {<><div className='commentP'><p>Issues List :</p></div>
            <div className='commentSection'>
           { comments.map((ele,index)=>{
                return(
                    <div key={index} className='comments'>
                        <p className='issueAt'>Issue At - {ele.issueAt}</p>
                        <ol>
                          {
                            ele?.comment?.map((el)=>{
                              return <li>{el}</li>
                            })
                          }
                        </ol>
                    </div>
                )
            })
            }
                    
            </div>
            </>
            }

            <div className="link">
                <button className={showProgressBar?'practiceLink disabled': 'practiceLink'} onClick={()=>{handleClickPracticeLink()}}>Practice Link</button>
            </div>
        </div>

        <div className='buttonsSections'>
        <button  className={showProgressBar?'buttonClass commit disabled':'buttonClass commit'} onClick={()=>{handleClickCommit()}}>{showProgressBar && <img src={Spinner} width={12} />} Commit</button>
        {/* <button className='buttonClass rtp'>Revert to Programer</button>*/}
        <button className={showProgressBar?'buttonClass rtv disabled': 'buttonClass rtv'} onClick={()=>{handleClickRevert()}}>{"Revert back"}</button> 
                
        </div>


        <GenricModal
        closable={true}
        width={900}
        data={mcqTestData}
        title={"Test Mcq Questions"}
        isOpen={testMcqModal}
        toggle={() => setTestMcqModal(false)}
      />
     
    </ShowAdminIssueDetailsWrapper>



  )

}
